import { Box, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import React, { PropsWithChildren } from 'react';
import { useFormContext } from 'react-hook-form';

import { useDictionariesContext } from '@/contexts/dictionaries/Dictionaries.context.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { CreateProcessFormModel } from '@/views/processesCreate/model/CreateProcessForm.model.ts';

export const ProcessCreateFormAssignContactOwnerAsProcessOwnerButton: React.FC<
  PropsWithChildren
> = ({ children }) => {
  const { t } = useTranslationWithPrefix('views.processesCreate.form.button');
  const { getValues, setValue, watch } = useFormContext<CreateProcessFormModel>();
  const { USERS_SHORT } = useDictionariesContext();

  const contactOwnerId = watch('contact.contactOwnerId');
  const processOwnerId = watch('processOwnerId');

  const handleAssignContactOwnerAsOwner = () => {
    const newOwnerId = getValues('contact.contactOwnerId');
    if (!newOwnerId) {
      return;
    }
    const ownerOption = USERS_SHORT.find(it => it.value === newOwnerId);
    if (!ownerOption) {
      return;
    }
    setValue('processOwnerId', ownerOption, { shouldDirty: true });
  };

  return (
    <Stack spacing={1}>
      {children}
      {contactOwnerId && processOwnerId && contactOwnerId !== processOwnerId.value && (
        <Box>
          <Button onClick={handleAssignContactOwnerAsOwner}>
            {t('assignContactOwnerAsOwner')}
          </Button>
        </Box>
      )}
    </Stack>
  );
};
